import { durations, easings } from 'components/animations/transitions';

export const CaseStudyPageVariants = {
  initial: { opacity: 0, y: 80 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      mass: 0.5,
      delay: 0.15,
      duration: durations.medium,
      easeIn: easings.pageTransition,
    },
  },
};
